"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var bus_sparql_parse_1 = require("@comunica/bus-sparql-parse");

var sparqlalgebrajs_1 = require("sparqlalgebrajs");
/**
 * A comunica Algebra SPARQL Parse Actor.
 */


var ActorSparqlParseAlgebra =
/*#__PURE__*/
function (_bus_sparql_parse_1$A) {
  _inherits(ActorSparqlParseAlgebra, _bus_sparql_parse_1$A);

  function ActorSparqlParseAlgebra(args) {
    var _this;

    _classCallCheck(this, ActorSparqlParseAlgebra);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ActorSparqlParseAlgebra).call(this, args));
    _this.prefixes = Object.freeze(_this.prefixes);
    return _this;
  }

  _createClass(ActorSparqlParseAlgebra, [{
    key: "test",
    value: function () {
      var _test = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(action) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(action.queryFormat && action.queryFormat !== 'sparql')) {
                  _context.next = 2;
                  break;
                }

                throw new Error('This actor can only parse SPARQL queries');

              case 2:
                return _context.abrupt("return", true);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function test(_x) {
        return _test.apply(this, arguments);
      }

      return test;
    }()
  }, {
    key: "run",
    value: function () {
      var _run = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(action) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", {
                  operation: sparqlalgebrajs_1.translate(action.query, {
                    quads: true,
                    prefixes: this.prefixes,
                    blankToVariable: true,
                    baseIRI: action.baseIRI
                  })
                });

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function run(_x2) {
        return _run.apply(this, arguments);
      }

      return run;
    }()
  }]);

  return ActorSparqlParseAlgebra;
}(bus_sparql_parse_1.ActorSparqlParse);

exports.ActorSparqlParseAlgebra = ActorSparqlParseAlgebra;